// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Admin__ApplicationDetailsController from "./admin/application_details_controller"
application.register("admin--application-details", Admin__ApplicationDetailsController)

import Admin__ApplicationStackController from "./admin/application_stack_controller"
application.register("admin--application-stack", Admin__ApplicationStackController)

import Admin__ApartmentTransfersController from "./admin/apartment_transfers_controller"
application.register("admin--apartment-transfers", Admin__ApartmentTransfersController)

import Admin__KeyReceiptDocumentController from "./admin/key_receipt_document_controller"
application.register("admin--key-receipt-document", Admin__KeyReceiptDocumentController)

import RecipientSelectorController from "./recipient_selector_controller"
application.register("recipient-selector", RecipientSelectorController)

import CustomerSelectController from "./customer_select_controller"
application.register("customer-select", CustomerSelectController)

import BuildingSelectController from "./building_select_controller"
application.register("building-select", BuildingSelectController)

import AutoAttachmentController from "./auto_attachment_controller"
application.register("auto-attachment", AutoAttachmentController)
